const handleApiError = (error) => {
    if (error.response) {
      // Server responded with an error status
      return {
        success: false,
        status: error.response.status,
        message: error.response.data?.message || "Something went wrong",
      };
    } else if (error.request) {
      // No response received from the server
      return {
        success: false,
        status: null,
        message: "No response from server. Please check your network.",
      };
    } else {
      // Other unexpected errors
      return {
        success: false,
        status: null,
        message: error.message || "An unexpected error occurred",
      };
    }
  };

  export {handleApiError}